import React from "react";
import { Box } from "@mui/material";
import PasswordEdit from "bundles/common/components/PasswordEdit";
import { FormattedMessage } from "react-intl";

const Password = () => {
  return (
    <Box>
      <Box
        component="h2"
        sx={{
          fontFamily: "Segoe UI Bold, system-ui, sans-serif",
          fontSize: "1.25rem",
          color: "hsl(178, 93%, 10%)",
          letterSpacing: "-0.01em",
          m: 0,
          mb: "24px",
        }}
      >
        <FormattedMessage id="settings.change_password" />
      </Box>
      <PasswordEdit userType="recruiter" />
    </Box>
  );
};

export default Password;
